import { render, staticRenderFns } from "./DepositModal.vue?vue&type=template&id=4415f5a0&scoped=true"
import script from "./DepositModal.vue?vue&type=script&lang=ts"
export * from "./DepositModal.vue?vue&type=script&lang=ts"
import style0 from "./DepositModal.vue?vue&type=style&index=0&id=4415f5a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4415f5a0",
  null
  
)

export default component.exports